
export default {
  myImage: 'https://www.lianlaoban.cn/myImage/',
  myVideo: 'https://blhc806.oss-cn-hangzhou.aliyuncs.com/websiteImg/',
  morenAvatar: 'moren.png',
  ossImageHead: 'https://blhc806.oss-cn-hangzhou.aliyuncs.com/',
  bucket: 'blhc806',
  avatarImg: 'avatar/',
  windowImg: 'window/',
  wmImg: 'wmImg/',
  websiteImg: 'websiteImg/',
}
//  判断对象非空
export const isBlank = (objce) => {
  return !!(objce === null || objce === '' || isFlag(objce, 'undefined') || isFlag(objce, 'null') || isFlag(JSON.stringify(objce),
    '{}') || isFlag(
      JSON.stringify(objce), '[]'));
}
/**
 * 判断对象是否相等
 * */
export const isFlag = (object, value) => {
  return object === value || JSON.stringify(object) === value || encodeURIComponent(object) === encodeURIComponent(value)
}
// 时间格式化
export const formatDate = (time, fmt) => {
  var date = new Date(Date.parse(time));
  const o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};
